import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PageStyleBaseComponent } from 'app/shared/components/base/page-style-base/page-style-base.component';
import { PaymentUrlInvalid } from 'app/shared/models/payment-urlinvalid.model';
import { PageStyleService } from 'app/shared/services/page-style.service';
import { PaymentService } from 'app/shared/services/payment.service';

@Component({
  selector: 'app-payment-request-url-invalid',
  templateUrl: './payment-request-url-invalid.component.html',
  styleUrls: ['./payment-request-url-invalid.component.scss']
})
export class PaymentRequestUrlInvalidComponent extends PageStyleBaseComponent implements OnInit {

  authorizationCode: string;
  currentObject: PaymentUrlInvalid;

  constructor(protected paymentService: PaymentService, protected pageStyleService: PageStyleService, private route: ActivatedRoute) {
    super(pageStyleService);
  }

  ngOnInit(): void {
    this.initializeObject();
    this.route
      .queryParams
      .subscribe(params => {
        this.authorizationCode = params.authorizationCode;

        super.initialize(this.authorizationCode, () => this.initializeStyles());
        this.paymentService.getObject<PaymentUrlInvalid>(
          '/payment/urlinvalid/' + this.authorizationCode,
          null,
          (paymentUrlInvalid) => {
            this.currentObject = paymentUrlInvalid;
          },
          true,
          false,
          true);
      });
  }

  initializeObject(): void {
    if (this.currentObject == null) {
      this.currentObject = new PaymentUrlInvalid();
    }
  }
}
